export const estadoCivilItems = [
  { value: 'solteiro', text: 'Solteiro(a)' },
  { value: 'casado', text: 'Casado(a)' },
  { value: 'divorciado', text: 'Divorciado(a)' },
  { value: 'viuvo', text: 'Viúvo(a)' },
  { value: 'separado', text: 'Separado(a)' },
];